import React, {useState} from "react";
import styled from "styled-components";

import NewNote from "./Common/NewNote";
import NoNotesButton from "./Common/NoNotesButton";
import Note from "./Common/Note";

// const Wrapper = styled.div`
//     position: fixed;
//     display:flex;
//     flex-direction:column;
//     bottom:0;
//     right: 0px;
//     height:100%;
//     border-left: 1px solid ${p => p.theme.colors.border};
//     padding-bottom:20px;
//     background-color: rgba(255,255,255,0.78)
//     z-index:1000000;
//     background:white;
// `

const Notes = styled.div`
  flex: 1;
  padding: 25px 15px 0;
  overflow-y: hidden;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 400px;
`;

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  bottom: 120px;
  right: 15px;
  height: 60%;
  border: 1px solid ${p => p.theme.colors.border};
  border-radius: 10px;
  padding-bottom: 20px;
  background-color: rgba(255, 255, 255, 0.78);
  z-index: 1000000;
  background: white;
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 6px, rgb(0 0 0 / 20%) 0px 2px 24px

`;

const CommentIcon = styled.div`
  background: rgb(66, 91, 118);
  color:white;
  height: 80px;
  width: 80px;
  position: fixed;
  bottom: 20px;
  right: 15px;
  font-size:40px;
  z-index:4000;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 6px, rgb(0 0 0 / 20%) 0px 2px 24px

`;

const Heading = styled.div`
  height: 60px;
  background:rgb(66, 91, 118);;
  color:white;
  border-top-left-radius:10px;
  border-top-right-radius:10px;
  display:flex;
  align-items:center;
  padding-left:15px;
  font-weight:bold;
  font-size:1.2rem;

`

const InnerWrapper = styled.div`

overflow-y: auto;

`

const ChatBox = ({ notes = [], addNote, formDataId }) => {

  const [showChat,setShowChat] = useState(true)

  return (
    <React.Fragment>
      {
        showChat && (
      
      <Wrapper className="sp-chat-box">
        <Heading>Meddelande</Heading>
        <Notes>
          <InnerWrapper>
          {notes.length === 0 &&
            <NoNotesButton icon={"fal fa-clipboard-list"} heading="No.Notes" />}
          {notes.length !== 0 &&
            notes.map((note, i) => {
              return (
                <Note key={i} type="external" {...note} removeNote={() => {}} />
              );
            })}
            </InnerWrapper>
        </Notes>
        <NewNote type="internal" addNote={addNote} formDataId={formDataId} />
      </Wrapper>
        )}

      <CommentIcon className={`fal fa-${showChat ? 'times' : 'comment'}`} onClick={()=>{setShowChat(!showChat)}} />
    </React.Fragment>
  );
};

export default ChatBox;
